import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  detailedData: [],
};

const tatMonitoringDetailedSlice = createSlice({
  name: "tatMonitoringDetailed",
  initialState,
  reducers: {
    fetchDetailed: (state, action) => {
      state.loading = true;
      state.error = null;
      state.detailedData = [];
    },
    fetchDetailedSuccess: (state, action) => {
      const { data } = action.payload;

      state.loading = false;
      state.detailedData = Array.isArray(data) ? data : [];
    },
    fetchDetailedFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.detailedData = [];
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { actions, reducer } = tatMonitoringDetailedSlice;
export const sliceKey = tatMonitoringDetailedSlice.name;